othIsWrapped